import { signIn } from 'aws-amplify/auth';
import { useCallback, useRef, useState } from "react";
import { Button, Card, Form, Spinner, Stack } from "react-bootstrap";
import background from "../assets/CSEM_background.jpg"
import { NewPasswordForm } from "./NewPasswordForm";

export function Login(props: { authLoading: boolean, onSuccessfulAuthentication: () => void }) {
    
    const emailInput = useRef<HTMLInputElement>(null);
    const passwordInput = useRef<HTMLInputElement>(null);

    const [loginLoading, setLoginLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [newPasswordRequired, setNewPasswordRequired] = useState(false);
    const [newPWRequiredAttributes, setNewPWRequiredAttributes] = useState<string[]>([]);

    const cognitoLogin = useCallback(async (e: React.SyntheticEvent) =>  {
        e.preventDefault();
        setLoginLoading(true);
        setErrorMessage("");
        const result = await signIn({ username: emailInput.current?.value ?? '', password: passwordInput.current?.value ?? '' }).catch((e: any) => {
            if (e.message !== "Incorrect username or password.") {
                throw e;
            }
            setErrorMessage(e.message);
            return null;
        }).finally(() => {
            setLoginLoading(false);
        });

        if (!result) return;

        if (result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
            setNewPasswordRequired(true);
            setNewPWRequiredAttributes((result.nextStep as any).missingAttributes ?? []);
            return;
        }

        if (result.isSignedIn)
            props.onSuccessfulAuthentication();
    }, []);

    return <div className="bg-img" style={{ backgroundImage: `url(${background})` }}>
        {props.authLoading && (
            <Card className="login-modal">
                <Spinner color="black"></Spinner>
            </Card>
        ) || (
                <Card className="login-modal">
                        <Stack gap={3}>

                    {!newPasswordRequired && (<>
                        <h2>Login to DigiInsulin</h2>
                        <Form onSubmit={cognitoLogin}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control disabled={loginLoading} type="email" placeholder="Enter email" ref={emailInput} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control disabled={loginLoading} type="password" placeholder="Password" ref={passwordInput} />
                            </Form.Group>
                            {errorMessage !== "" && (
                            <div className="alert alert-danger" role="alert">
                                {errorMessage}
                            </div>)}
                            

                            <Button disabled={loginLoading} variant="primary" type="submit">
                                Submit
                            </Button>
                        </Form></>
                    ) || (<NewPasswordForm requiredAttributes={newPWRequiredAttributes} onSuccessfulAuthentication={
                        props.onSuccessfulAuthentication
                    } onSessionExpired={e => {
                        setErrorMessage(e.message);
                        setNewPWRequiredAttributes([]);
                        setNewPasswordRequired(false);
                    }}/>)}
                    </Stack>
                    
                </Card>
            )}


    </div>

}